import enTranslation from 'src/assets/i18n/en.json';
import frTranslation from 'src/assets/i18n/fr.json';
import esTranslation from 'src/assets/i18n/es.json';
import csTranslation from 'src/assets/i18n/cs.json';
import daTranslation from 'src/assets/i18n/da.json';
import deTranslation from 'src/assets/i18n/de.json';
import itTranslation from 'src/assets/i18n/it.json';
import nlTranslation from 'src/assets/i18n/nl.json';
import jaTranslation from 'src/assets/i18n/ja.json';

export const TRANSLATIONS = {
  en: enTranslation,
  fr: frTranslation,
  es: esTranslation,
  cs: csTranslation,
  da: daTranslation,
  de: deTranslation,
  it: itTranslation,
  nl: nlTranslation,
  ja: jaTranslation,
} as const;

export type SupportedLang = keyof typeof TRANSLATIONS;
